<script lang="ts">
  import type { CalculatorCard } from '../../types/calculator';

  interface Props {
    calculator: CalculatorCard;
  }

  let { calculator }: Props = $props();
</script>

<div class="group flex flex-col bg-white rounded-xl border border-[#e5e7eb] shadow-[0_2px_8px_rgba(0,0,0,0.04)] hover:shadow-[0_8px_24px_rgba(0,0,0,0.08)] hover:border-primary/30 transition-all duration-300 overflow-hidden">
  <div class="p-6 flex flex-col flex-1 gap-4">
    <div class="size-12 rounded-full {calculator.iconBgClass} {calculator.iconTextClass} flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
      <span class="material-symbols-outlined text-2xl">{calculator.icon}</span>
    </div>
    <div class="flex flex-col gap-2">
      <h3 class="text-[#111418] text-lg font-bold leading-tight">{calculator.title}</h3>
      <p class="text-[#617589] text-sm leading-relaxed">
        {calculator.description}
      </p>
    </div>
  </div>
  <div class="px-6 pb-6 mt-auto">
      <a href={calculator.href} class="w-full flex items-center justify-center rounded-lg h-10 px-4 bg-white border border-gray-200 text-[#111418] text-sm font-bold shadow-sm hover:bg-gray-50 hover:text-primary transition-colors no-underline">
          Start Calculation
      </a>
  </div>
</div>
